import styled from 'styled-components';

export const BankSlipCard = styled.div`
    background-color: ${({ theme }) => theme.colors.gray000};
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

`;

export const BankSlipHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
`;

export const BankSlipIcon = styled.div`
    width: 48px;
    height: 48px;
    background-color: ${({ theme }) => theme.colors.primary100};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.primary700};
`;

export const BankSlipTitle = styled.h3`
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
`;

export const BankSlipInfo = styled.div`
    background-color: ${({ theme }) => theme.colors.gray100};
    border-radius: 8px;
    padding: 1.5rem;
    margin: 1rem 0;
`;

export const BankSlipInfoText = styled.p`
    color: ${({ theme }) => theme.colors.text.secondary};
    line-height: 1.6;
    margin: 0;
`;

export const BankSlipButton = styled.button`
    background-color: ${({ theme }) => theme.colors.primary800};
    color: ${({ theme }) => theme.colors.gray000};
    border: none;
    border-radius: 8px;
    padding: 1rem 2rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    &:hover {
        background-color: ${({ theme }) => theme.colors.primary800};
    }
`;

export const PaymentTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1rem;
`;

export const PaymentTitle = styled.h2`
    font-size: ${(props) => props.theme.fontSizes[2]};
    font-weight: 700;
    color: ${(props) => props.theme.colors.gray900};
    text-align: center;
`;

export const PaymentSubtitle = styled.p`
    font-size: ${(props) => props.theme.fontSizes[8]};
    font-weight: 400;
    color: ${(props) => props.theme.colors.gray600};
    text-align: center;
`;

export const PaymentHeader = styled.div`
    margin-bottom: 2rem;

    display: flex;
    align-items: center;
    justify-content: center;
`;
